import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { CheckCircleOutlineGrayIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { SmallTagBase } from '@/components/ui/Tag/SmallTagBase';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * クライアント：提案希望の送付状況を表示するタグ（ボタンによる制御を含む場合はProposalRequestButtonを使用すること）
 * @param props
 * @constructor
 */
export const RfpProposalRequestStatus = (props) => {
    const { className = '' } = props;
    return (_jsx(SmallTagBase, Object.assign({ className: clsx('bg-gray-50', 'border border-solid border-gray-400', 'w-[65px]', className), isFullRounded: true, isKanjiTopFixed: true, textColor: 'inactive' }, { children: _jsxs(IconTextGroup, Object.assign({ align: 'center' }, { children: [_jsx(CheckCircleOutlineGrayIcon, { size: 'xs' }), _jsx("span", { children: "\u9001\u4ED8\u6E08" })] })) })));
};
